export default Object.freeze({
	NOT_STARTED: 1,
	ID_VERIFIED: 2,
	VERIFIED: 3,
	FAILED: 4,
	WITNESS_INCOMPLETE: 5,
	WITNESS_COMPLETE: 6,
});